import { formatExecutionCandleTypeLabel } from "../utils/executionCandleTimeframe";
import { MARKET_DATA_RESOLVE_DIALOG_COPY } from "./marketDataResolveDialogCopy";

const confirmSourceCta = MARKET_DATA_RESOLVE_DIALOG_COPY.confirmMarketDataSource;

export const MARKET_DATA_UNAVAILABLE_COPY = {
  hyperliquid_history_insufficient: {
    title: (tf?: string) =>
      tf
        ? `Hyperliquid history unavailable for ${tf}`
        : "Hyperliquid history unavailable for this timeframe",
    ctaCoarserTf: (tf: string) => `Switch to ${formatExecutionCandleTypeLabel(tf)}`,
    ctaChangeSource: "Change market data source",
    footer: (tf: string, earliest: string) =>
      `Native ${formatExecutionCandleTypeLabel(tf)} data on Hyperliquid from ${earliest}`,
  },
  liquid_history_insufficient: {
    title: () => "Chart unavailable for this timeframe",
    ctaCoarserTf: (tf: string) => `Switch to ${formatExecutionCandleTypeLabel(tf)}`,
    ctaChangeSource: "Change market data source",
    footer: (tf: string, earliest: string) =>
      `Native ${formatExecutionCandleTypeLabel(tf)} data from ${earliest}`,
  },
  market_data_connector_required: {
    title: () => "Chart data unavailable",
    ctaChangeSource: confirmSourceCta,
  },
  market_data_preference_unavailable: {
    title: () => "Chart data unavailable",
    ctaChangeSource: confirmSourceCta,
  },
  market_data_consent_required: {
    title: () => "Market data consent required",
    ctaChangeSource: confirmSourceCta,
  },
  no_trade_span: {
    title: () => "No trades in this date range",
    ctaChangeSource: "Change market data source",
  },
  default: {
    title: () => "Chart unavailable for this timeframe",
    ctaCoarserTf: (tf: string) => `Switch to ${formatExecutionCandleTypeLabel(tf)}`,
    ctaChangeSource: "Change market data source",
  },
} as const;
